/* @flow */
import * as React from 'react';

const Shield = props => (
  <svg
    width={78}
    height={91}
    viewBox="0 0 78 91"
    stroke="#1C1F34"
    strokeWidth={3}
    fillRule="evenodd"
    strokeLinecap="round"
    strokeLinejoin="round"
    fill="none"
    {...props}>
    <path
      fill="#FFFFFF"
      d="M34.927,79.308 C68.354,63.872 68.354,16.496 68.354,16.496 C50.694,14.263 34.927,1.5 34.927,1.5 C34.927,1.5 19.16,14.263 1.5,16.496 C1.5,16.496 1.5,63.872 34.927,79.308 Z"
    />
    <path
      stroke="none"
      strokeWidth={1}
      fill="#DEDEDE"
      d="M53.476,55.102 C53.477,54.284 53.63,53.566 53.892,52.938 C43.66,53.222 35.419,61.614 35.419,71.914 C35.419,74.357 35.899,76.687 36.743,78.835 C37.048,78.646 37.375,78.475 37.737,78.333 C41.452,76.876 44.925,75 48.299,72.957 C51.082,67.336 53.467,61.468 53.476,55.102"
    />
    <path
      stroke="none"
      strokeWidth={1}
      fill="#677BC5"
      d="M62.058,21.445 C50.354,18.711 40.181,12.55 34.927,8.936 L34.927,40.404 L58.381,40.404 C60.676,32.86 61.65,25.889 62.058,21.445"
    />
    <path
      stroke="none"
      strokeWidth={1}
      fill="#677BC5"
      d="M34.927,40.404 L11.473,40.404 C15.065,52.211 21.9,65.426 34.927,72.591 L34.927,40.404 Z"
    />
    <path d="M34.927,72.591 C13.576,60.849 8.842,32.849 7.795,21.445 C19.501,18.711 29.673,12.551 34.927,8.937 C40.181,12.551 50.354,18.711 62.058,21.445 C61.012,32.844 56.279,60.848 34.927,72.591 Z" />
    <path
      stroke="none"
      strokeWidth={1}
      fill="#677BC5"
      d="M75.922,71.913 C75.922,62.248 68.086,54.411 58.42,54.411 C48.754,54.411 40.918,62.248 40.918,71.913 C40.918,81.579 48.754,89.415 58.42,89.415 C68.086,89.415 75.922,81.579 75.922,71.913"
    />
    <path d="M75.922,71.913 C75.922,62.248 68.086,54.411 58.42,54.411 C48.754,54.411 40.918,62.248 40.918,71.913 C40.918,81.579 48.754,89.415 58.42,89.415 C68.086,89.415 75.922,81.579 75.922,71.913 Z" />
    <polyline stroke="#FFFFFF" points="49.904 74.822 54.061 78.979 66.774 66.266" />
    <path d="M34.5,8.936 L34.5,72.59" />
    <path d="M11.47,40.5 L58.273,40.5" />
  </svg>
);

export default Shield;



// WEBPACK FOOTER //
// ./src/assets/images/icons/shield.js